The relative place of the status in the overall process.
